import React from 'react'

import cn from 'classnames'
import { css, StyleSheet } from 'aphrodite'
import { NavLink } from 'react-router-dom'
import { useModal } from '../../hooks/modal'
import { useDeleteRequest } from '../../hooks/request'
import { MARKET_DETAIL } from '../../urls'
import MarketUpdate from '../settings/market/MarketUpdate'

export default function RentItem({ market, markets }) {
    const productRemove = useDeleteRequest({ url: MARKET_DETAIL.replace('{id}', market.id) })

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            await productRemove.request()
            markets.request()
        }
    }

    const [showUpdateModal, hideUpdateModal] = useModal(
        <MarketUpdate
            item={market}
            onSuccess={() => {
                markets.request()
                hideUpdateModal()
            }}
        />,
    )

    function format(value) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            useGrouping: true,
        })
            .format(value)
            .replace(/,/g, ' ')
    }

    return (
        <div className="column is-12-mobile is-6-tablet is-4-desktop is-4-widescreen">
            <div className={cn('box p-4 is-full-height', css(styles.box, styles.boxHover))}>
                <NavLink to={`/rent/${market.id}`}>
                    <p className="title is-5 has-text-link mb-2">{market?.name}</p>
                </NavLink>

                <table className="table is-fullwidth is-bordered is-narrow">
                    <tbody>
                        <tr>
                            <td>
                                <span className="icon-text has-text-grey">
                                    <span className="icon">
                                        <ion-icon name="business-outline" />
                                    </span>
                                    <span className="has-text-weight-medium">Майдон</span>
                                </span>
                            </td>
                            <td>{market?.square} m²</td>
                        </tr>
                        <tr>
                            <td>
                                <span className="icon-text has-text-grey">
                                    <span className="icon">
                                        <ion-icon name="person-outline" />
                                    </span>
                                    <span className="has-text-weight-medium">Директор</span>
                                </span>
                            </td>
                            <td>{market?.directorName}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className="icon-text has-text-grey">
                                    <span className="icon">
                                        <ion-icon name="call-outline" />
                                    </span>
                                    <span className="has-text-weight-medium">Телефон</span>
                                </span>
                            </td>
                            <td>{market?.phone}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className="icon-text has-text-grey">
                                    <span className="icon">
                                        <ion-icon name="location-outline" />
                                    </span>
                                    <span className="has-text-weight-medium">Манзил</span>
                                </span>
                            </td>
                            <td>{market?.address}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className="icon-text has-text-grey">
                                    <span className="icon">
                                        <ion-icon name="cash-outline" />
                                    </span>
                                    <span className="has-text-weight-medium">Ижара суммаси</span>
                                </span>
                            </td>
                            <td>{format(market?.price)}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className="icon-text has-text-grey">
                                    <span className="icon">
                                        <ion-icon name="trending-down-outline" />
                                    </span>
                                    <span className="has-text-weight-medium">Харажатлар</span>
                                </span>
                            </td>
                            <td>{format(market?.totalExpense)}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className="icon-text has-text-grey">
                                    <span className="icon">
                                        <ion-icon name="trending-up-outline" />
                                    </span>
                                    <span className="has-text-weight-medium">Даромад</span>
                                </span>
                            </td>
                            <td>{format(market?.totalIncome)}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className="icon-text has-text-grey">
                                    <span className="icon">
                                        <ion-icon name="alert-outline" />
                                    </span>
                                    <span className="has-text-weight-medium">Қарздорлик</span>
                                </span>
                            </td>
                            <td>{format(market?.totalBalance)}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className="icon-text has-text-link">
                                    <span className="icon">
                                        <ion-icon name="flash-outline" />
                                    </span>
                                    <span className="has-text-weight-medium">Коммунал тўловлар</span>
                                </span>
                            </td>
                            <td className="has-text-link has-text-weight-semibold">
                                {format(market?.utilityTotal || market?.utilityTotal || 0)}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div className="is-flex is-justify-content-space-between">
                    <button onClick={onDelete} className="button is-danger is-light is-small">
                        <span className="icon">
                            <ion-icon name="trash-outline" />
                        </span>
                        <span>Ўчириш</span>
                    </button>
                    <button onClick={showUpdateModal} className="button is-info is-light is-small">
                        <span className="icon">
                            <ion-icon name="create-outline" />
                        </span>
                        <span>Таҳрирлаш</span>
                    </button>
                </div>
            </div>
        </div>
    )
}
const styles = StyleSheet.create({
    box: {
        borderWidth: 2,
        borderColor: 'rgba(255, 99, 71, 0.5)',
        borderRadius: 10,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.1,
        shadowRadius: 10,
        elevation: 3,
        padding: 10,
    },
    boxHover: {
        borderColor: 'rgba(255, 69, 0, 0.8)',
        shadowOpacity: 0.2,
        elevation: 5,
    },
})
